export default {
   "cndname": "",
   "cndmemberid": "",
   "description": "",
   "details": "",
   "isuncontested": false,
   "isappointed": false,
}
